import React from "react";

export const Logo = ({ className = "", light = false }) => (
    <span className={`inline-flex items-center gap-0.5 font-serif font-bold tracking-tight ${className}`}>
        <span style={{ color: light ? "#F6F2E9" : "#20372F" }}>WHY-AM</span>
        <span style={{ color: "#C8A66B" }}>.</span>
    </span>
);

export default Logo;
